export default __webpack_public_path__ + "static/media/10-thumbnail.ab46f722.png";